import { ConfigSystemRepository } from '../ports/repositories';
import { ConfigSystemEntity } from '../entities';
import { RankingConfigurationPayload } from '../ports/payloads';

export class UpdateSalesTargetSettingUsecase {
  constructor(private readonly configSystemRepository: ConfigSystemRepository) {}

  async run(payload: RankingConfigurationPayload[]): Promise<ConfigSystemEntity> {
    return this.configSystemRepository.updateSalesTargetRanking(payload);
  }
}
